<template>
  <core-etapa4 />
</template>

<script>

export default {
  components: {
    CoreEtapa4: () => import('@/components/core/Etapa4')
  }
}
</script>
